type BarcodeProfiles = 'Profile1' | 'Profile2';

interface IBarcodeProfile
{
    character: string;
    characterCode: number;
}

class SiteKeyboard
{
    private readonly _site: Site;

    private _readBarcode: boolean = false;
    private _readBarcodeString: string[] = [];
    private _readBarcodeTimeout: number = 0;
    private _profiles: { [k in BarcodeProfiles]: IBarcodeProfile } = {
        "Profile1": {
            character: "\\",
            characterCode: 220
        },
        "Profile2": {
            character: "`",
            characterCode: 192
        }
    }
    private _profile: IBarcodeProfile;

    constructor (site: Site, profile: BarcodeProfiles)
    {
        this._site = site;
        this._profile = this._profiles[profile];
        
        QueryElement.get(document.body).on("textInput", (e: Event) => {
            if (e.data == null)
                return;
            
            if (e.data == this._profile.character) {
                if (this._readBarcode == false)
                    this.startBarcode();
                else
                    this.endBarcode();
                
                e.stop()
            } else {
                if (this._readBarcode == true) {
                    this.read(e, e.data);
                }
            }
        });
        
        QueryElement.get(document.body).on("keydown", (e: KeyboardEvent) => {
            if(this.keyDown(e.keyCode)) {
                e.stop();
            } else {
                if (this._readBarcode == true) {
                    if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 65 && e.keyCode <= 90)) {
                        this.read(e, e.key);
                    }
                }
            }
        });
    }
    read(e: Event, key: string) {
        this._readBarcodeString.push(key);
        this.prolongBarcode();
        e.stop();
    }
    keyDown(keyCode: number): boolean {
        switch(keyCode) {
            case this._profile.characterCode:
                if (this._readBarcode == false) 
                    this.startBarcode();
                else
                    this.endBarcode();
                return true;
            case 27: // ESC
                this._site.back();
                return true;
            case 112: // F1
                this._site.containerSide();
                return true;
            case 113: // F2
                this._site.showHideConfidential();
                return true;
            case 114: // F3
                this._site.switchTheme();
                return true;
        }
        
        return false;
    }

    startBarcode() {
        this._readBarcode = true;
        this._readBarcodeString = [];

        this.prolongBarcode();
    }
    prolongBarcode() {
        window.clearTimeout(this._readBarcodeTimeout);
        this._readBarcodeTimeout = window.setTimeout(() => this.endBarcode(), 5000);
    }
    endBarcode() {
        this._readBarcode = false;
        window.clearTimeout(this._readBarcodeTimeout);

        if (this._readBarcodeString.length == 0)
            return;

        var barcode = this._readBarcodeString.join("");

        var barcodeReturn = new BarcodeMessage();
        barcodeReturn.barcode = barcode;
        console.log("Found barcode " + barcode);
        this._site.trigger("qts.observer.event", false, barcodeReturn);
    }
}